// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>17</span>&nbsp;&nbsp;&#145;I will make your name to be remembered through all generations;&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;therefore shall the peoples praise you for ever and ever.&#146;<br> </p> </div></div>";
// Exports
module.exports = code;